import { makeStyles } from "@material-ui/core";
import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

const useStyles = makeStyles((theme) => ({
  legendStyleHorizontalBarChart: {
    color: "#362B73",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "16px",
    opacity: 0.56,
  },
}));

function calculateMaximumValue(data) {
  const reducer = (previousValue, currentValue) =>
    Math.max(previousValue, currentValue.value);
  return data.reduce(reducer, 0);
}

function RenderCustomizedLabel(props) {
  const { y, index, chartData, labelProperty } = props;
  const styles = useStyles();
  const label = chartData[index][labelProperty];

  return (
    <>
      {/* <text
        x="100%"
        y={y}
        dy={-8}
        fill="black"
        textAnchor="end"
        className={styles.legendStyleHorizontalBarChart}
      >
        {value}
      </text> */}
      <text
        x={"0%"}
        y={y}
        dy={18}
        fill="black"
        className={styles.legendStyleHorizontalBarChart}
        textAnchor="start"
      >
        {label}
      </text>
    </>
  );
}

function CustomizedLabelX(props) {
  const { x, y, payload } = props;
  const styles = useStyles();

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={24}
        textAnchor="end"
        className={styles.legendStyleHorizontalBarChart}
      >
        {payload.value.toFixed(0) + (payload.value < 1 ? "" : " Days")}
      </text>
    </g>
  );
}

const HorizontalBarChart = (props) => {
  const { data, colorProperty, valueProperty, labelProperty } = props;
  const maximumValue = calculateMaximumValue(data);
  const styleParameter = {
    margin: { top: 16, right: 40, left: 112, bottom: 24 },
    radius: [14, 14, 14, 14],
  };

  return (
    <ResponsiveContainer width={"100%"} height={65 * data.length}>
      <BarChart layout="vertical" data={data} margin={styleParameter.margin}>
        <CartesianGrid
          horizontal={false}
          // verticalCoordinatesGenerator={(props) => {
          //   let res = [];
          //   const inc = 120;
          //   for (
          //     let i = props.offset.left + 60;
          //     i < props.width - props.offset.right;
          //     i += inc
          //   ) {
          //     res.push(i);
          //   }
          //   return res;
          // }}
        />
        <XAxis
          axisLine={false}
          type="number"
          domain={[0, maximumValue * 1.3]}
          tickLine={false}
          tick={<CustomizedLabelX />}
        />
        <YAxis
          type="category"
          tick={false}
          axisLine={false}
          dataKey={labelProperty}
        />
        <Bar
          background={{ fill: "rgb(234, 238, 249)", radius: 28 }}
          dataKey={valueProperty}
          radius={styleParameter.radius}
          barSize={28}
          label={
            <RenderCustomizedLabel
              chartData={data}
              labelProperty={labelProperty}
            />
          }
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry[colorProperty]}
              stroke={"rgb(234, 238, 249)"}
              strokeWidth={8}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

HorizontalBarChart.defaultProps = {
  colorProperty: "color",
  valueProperty: "value",
  labelProperty: "label",
};

export default HorizontalBarChart;
